var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"character-prose"},[(_vm.verse.ref && _vm.verse.ref.length > 0)?_c('text-ref',{attrs:{"id":_vm.verse.ref,"text":_vm.verse.text}}):_c('text-with-refs',{attrs:{"text":_vm.verse.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }